//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { windVane } from '../../../utils/tmallGenius'
import { bindDeviceOnline } from '../../../api/index'
import imgBase64 from '../../../items/imgBase64.vue'
//
export default {
  components: { imgBase64, },
  data() {
    return {
      connectTimeCountDown: 120,
      connectTimeCountDownTimer: undefined,
      log: '连接中...',
      httpTimer: undefined,
      wifi: '', //上一步填写的wifi
    }
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("尝试与设备建立连接");
    next();
  },
  /*------------------------------------------- 启动运行 -------------------------------------------------------*/
  created() {
    this.controllerName = this.$route.query.name;
    this.wifi = this.$route.query.wifi;
    let uid = sessionStorage.getItem('controllerUid');
    //有一开始的保存的设备信息
    if (uid) {
      this.timeCounting();  //开始倒计时
      this.httpTimer = setInterval(() => {
        this.bindController(uid); //没收到就一直调用
      }, 3000);
    } else {
      this.log = '未知错误，请重试';
      this.clearTimeCnt();
    }
  },
  beforeDestroy() {
    this.clearTimeCnt();
  },
  methods: {
    /*------------------------------------------- 自定义方法 -------------------------------------------------------*/
    /*  绑定设备
    * */
    bindController(uid) {
      //继续发送
      bindDeviceOnline({
        token: sessionStorage.getItem('token'),
        uid: uid, //'5ccf7f1406da'
      }).then(res => {
        if (this.connectTimeCountDown === 0) return;  // 防止超时后，网络回调比较慢
        //成功
        if (res.status === 0) {
          this.log = '连接成功';
          this.$router.replace({
            path: '/connect/wifi/done',
            query: {
              name: this.controllerName,
            }
          });
        }
        //被绑定
        else if (res.status === 4 || res.status === 1) {
          //alert(JSON.stringify(res));
          const data = res.data || {};
          const user = data.phone || data.email || data.userName || '未知';
          this.log = '该设备已经被账号' + user + '绑定！';
          this.connectTimeCountDown = 0;  //停止计时
          this.clearTimeCnt();
        }
        //等待
        else if (res.status === 5) {
          this.log = '等待设备联网中...';
        }
        //错误
        else {
          alert(JSON.stringify(res))
        }
      }).catch((res) => {
        this.log = '重试中...';
      });
    },
    /*  计时函数
    * */
    timeCounting() {
      this.connectTimeCountDownTimer = setInterval(() => {
        this.connectTimeCountDown--;
        if (this.connectTimeCountDown <= 0) {
          this.connectTimeCountDown = 0;
          this.log = '连接超时，请检查网路或者wifi密码后重试';
          this.clearTimeCnt();
        }
      }, 1000);
    },
    /*  清除计时定时器
    * */
    clearTimeCnt() {
      clearInterval(this.connectTimeCountDownTimer);
      clearInterval(this.httpTimer);
    },
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
    cancelClick() {
      this.$router.go(-1); //回到首页，无历史记录
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/BindController.vue